var exports = {
  "SP": "commentIndicatorContainer__xtxGbl",
  "GE": "AvatarStack__xPO3jy",
  "at": "Compact__eOA6t0",
  "wL": "Relaxed__9GvAxC",
  "Ut": "textStyles__R30Q30",
};

module.exports = exports;
